export default __webpack_public_path__ + "static/media/filter-icon-blue.0d1be7ee.svg";